import Hotel from "@material-symbols/svg-500/rounded/hotel.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const HotelIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Hotel });
	return <Icon />;
};

export default memo(HotelIcon);
